import React from 'react';

import {
  Form,
  Formik,
  ErrorMessage
} from 'formik';
import { Messages } from "../../../../../../layout/Messages/Messages";
import { NOTIFICATION_ERROR } from "../../../../../../../store/actions/types";
import { CreateAdminUserSchema } from "../../../../../../../helpers/schemas";
import { TextField } from "../../../../../auth/TextField";
import { Button } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { NOTIFICATION_CREATE_ADMIN_USER } from '../../../../../../../config/notifications';

const CreateUserForm = (props) => {
  return (
    <Formik
      initialValues={
        {
          firstName: '',
          lastName: '',
          email: '',
        }
      }
      validationSchema={CreateAdminUserSchema}
      validateOnChange={false}
      enableReinitialize={true}

      onSubmit={async (values, { resetForm }) => {
        let reset = await props.submit( values );

        if (reset) {
          resetForm( { values: '' } );
          if (values.action === 'save') {
            props.toggle();
          }
        }
      }}
    >
      {
        (formik_props) => (
          <Form>
            <div className="mx-2">
              <Messages notificationId={NOTIFICATION_CREATE_ADMIN_USER}/>
              <Messages
                color="danger"
                notificationId="formValidation"
                type={NOTIFICATION_ERROR}
                formikProps={formik_props}
              >
                <ErrorMessage name="firstName" component="div"
                              data-testid="errors-first_name"
                              className="field-error"/>

                <ErrorMessage name="lastName" component="div"
                              data-testid="errors-last_name"
                              className="field-error"/>

                <ErrorMessage name="email" component="div"
                              data-testid="errors-email"
                              className="field-error"/>
              </Messages>

              <TextField
                name="firstName"
                handleBlur={formik_props.handleBlur}
              />

              <TextField
                name="lastName"
                handleBlur={formik_props.handleBlur}
              />

              <TextField
                name="email"
                handleBlur={formik_props.handleBlur}
              />

              <div className="text-center text-sm-right py-3">
                <Button className="mt-2 mt-sm-0" name="add" type="submit"
                        color="primary"
                        onClick={() => formik_props.setFieldValue( 'action', 'add' )}>
                  <FormattedMessage id="button.add"/>
                </Button>
                <Button className="mt-2 mt-sm-0" name="save" type="submit"
                        color="primary"
                        onClick={() => formik_props.setFieldValue( 'action', 'save' )}>
                  <FormattedMessage id="button.finish_and_close"/>
                </Button>
                <Button className="mt-2 mt-sm-0" color="secondary"
                        onClick={props.toggle}>
                  <FormattedMessage id="button.cancel"/>
                </Button>
              </div>

            </div>
          </Form>
        )
      }
    </Formik>
  )
}

export {
  CreateUserForm
}
